import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=30d6ccea&scoped=true&"
import script from "./goodsDetail.vue?vue&type=script&lang=js&"
export * from "./goodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=30d6ccea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d6ccea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30d6ccea')) {
      api.createRecord('30d6ccea', component.options)
    } else {
      api.reload('30d6ccea', component.options)
    }
    module.hot.accept("./goodsDetail.vue?vue&type=template&id=30d6ccea&scoped=true&", function () {
      api.rerender('30d6ccea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/cate/goodsDetail.vue"
export default component.exports